import { Injectable } from '@angular/core';
import { ExternalToast, toast } from 'ngx-sonner';

export type ToastOptions = ExternalToast;

/**
 * App-wide toast API backed by ngx-sonner (Sonner for Angular).
 * Prefer this service over calling `toast` directly so messaging stays consistent.
 */
@Injectable({
  providedIn: 'root'
})
export class ToastService {
  success(message: string, options?: ToastOptions): string | number {
    return toast.success(message, options);
  }

  error(message: string, options?: ToastOptions): string | number {
    return toast.error(message, options);
  }

  info(message: string, options?: ToastOptions): string | number {
    return toast.info(message, options);
  }

  warning(message: string, options?: ToastOptions): string | number {
    return toast.warning(message, options);
  }

  message(message: string, options?: ToastOptions): string | number {
    return toast(message, options);
  }

  loading(message: string, options?: ToastOptions): string | number {
    return toast.loading(message, options);
  }

  dismiss(id?: string | number): void {
    toast.dismiss(id);
  }
}
